package navigation.settings.currency.addcurrency

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.settings.domain.repository.ConfigurationRepository
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.currency.domain.repository.CurrencyRepository
import com.essntl.features.currency.ui.addcurrency.AddCurrencyEvent
import com.essntl.features.currency.ui.addcurrency.AddCurrencyState
import com.essntl.features.currency.ui.addcurrency.AddCurrencyViewModel

class AddCurrencyScreenModel(
    currencyRepository: CurrencyRepository,
    configurationRepository: ConfigurationRepository,
    loadingManager: LoadingManager,
) : StateScreenModel<AddCurrencyState>(AddCurrencyState()) {

    private val viewModel =
        AddCurrencyViewModel(
            currencyRepository = currencyRepository,
            configurationRepository = configurationRepository,
            loadingManager = loadingManager,
            state = mutableState,
            scope = screenModelScope,
        )

    fun onEvent(event: AddCurrencyEvent) = viewModel.onEvent(event)
}